"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteService = void 0;
var helpers_1 = require("../helpers");
var main_1 = require("../main");
var mfe_1 = require("../mfe");
var RemotesImporter_service_1 = require("./RemotesImporter.service");
var RemoteService = /** @class */ (function (_super) {
    __extends(RemoteService, _super);
    function RemoteService() {
        var _this = _super.call(this) || this;
        _this.MAX_ATTEMPTS = main_1.Helpers.EnvironmentHelper.isLocalEnvironment() ? 1 : 3;
        _this.isInitialized = false;
        _this.remotesMap = {};
        _this.waitingList = [];
        return _this;
    }
    RemoteService.prototype.initRemotesMapOnlyClient = function (ENV_CONFIG) {
        var mfeNames = Object.values(mfe_1.MFE_NAMES);
        return this.initRemotesMapOnlyClientSideByMfeNames(mfeNames, helpers_1.ModuleFederationHelper.initWebpackLoadRemoteClientSide(ENV_CONFIG));
    };
    RemoteService.prototype.initRemotesMapOnlyClientSideByMfeNames = function (mfeNames, webpackLoadRemoteClientSide) {
        var newRemoteMap = this.getRemotesMapOnlyClientSideFromMfeNamesList(mfeNames, webpackLoadRemoteClientSide);
        return this.initRemotesMap(newRemoteMap);
    };
    RemoteService.prototype.getRemotesMapOnlyClientSideFromMfeNamesList = function (mfeNames, webpackLoadRemoteClientSide) {
        var _this = this;
        return mfeNames.reduce(function (acc, mfeName) {
            var remotes = _this.getRemotesMapOnlyClientSideFromMfeName(mfeName, webpackLoadRemoteClientSide);
            return __assign(__assign({}, acc), remotes);
        }, {});
    };
    RemoteService.prototype.getRemotesMapOnlyClientSideFromMfeName = function (__mfeName__, webpackLoadRemoteClientSide) {
        var _a;
        return _a = {},
            _a[__mfeName__] = this.getRemoteMapOnlyClientSide(__mfeName__, webpackLoadRemoteClientSide),
            _a;
    };
    RemoteService.prototype.getRemoteMapOnlyClientSide = function (__mfeName__, webpackLoadRemoteClientSide) {
        return {
            import: webpackLoadRemoteClientSide(__mfeName__),
        };
    };
    RemoteService.prototype.initRemotesMap = function (newRemoteMap) {
        if (newRemoteMap === void 0) { newRemoteMap = {}; }
        if (!this.isInitialized) {
            this.remotesMap = newRemoteMap;
            this.isInitialized = true;
        }
        this.waitingList.forEach(function (resolveInstance) { return resolveInstance(); });
        this.waitingList = [];
    };
    RemoteService.prototype.resetRemotesMap = function () {
        this.remotesMap = {};
        this.isInitialized = false;
    };
    RemoteService.prototype.afterInitialized = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.isInitialized) {
                resolve();
            }
            else {
                _this.waitingList.push(resolve);
            }
        });
    };
    RemoteService.prototype.updateChildrenDependencies = function (ContainerMfeName, newChildrenRemoteDeps) {
        if (this.remotesMap[ContainerMfeName]) {
            this.remotesMap[ContainerMfeName].childrenRemoteDeps =
                newChildrenRemoteDeps;
        }
    };
    RemoteService.prototype.isAvailableRemote = function (__mfeName__) {
        return __mfeName__ && __mfeName__ in this.remotesMap;
    };
    RemoteService.prototype.getRemote = function (__mfeName__, isClientSideImport) {
        var remote;
        if (this.isAvailableRemote(__mfeName__)) {
            if (isClientSideImport &&
                "clientSideRemote" in this.remotesMap[__mfeName__]) {
                remote = this.remotesMap[__mfeName__].clientSideRemote;
            }
            else if (!isClientSideImport &&
                "serverSideRemote" in this.remotesMap[__mfeName__]) {
                remote = this.remotesMap[__mfeName__].serverSideRemote;
            }
        }
        return remote || null;
    };
    RemoteService.prototype.setRemote = function (remote, isClientSideImport) {
        this.remotesMap[remote.__mfeName__].execImport = undefined;
        if (isClientSideImport) {
            this.remotesMap[remote.__mfeName__].clientSideRemote =
                remote;
        }
        else {
            this.remotesMap[remote.__mfeName__].serverSideRemote =
                remote;
        }
    };
    RemoteService.prototype.getExecImport = function (__mfeName__) {
        return this.remotesMap[__mfeName__].execImport;
    };
    RemoteService.prototype.setExecImport = function (__mfeName__, execPromise) {
        this.remotesMap[__mfeName__].execImport = execPromise;
    };
    RemoteService.prototype.isAlreadyImported = function (componentName, isClientSideImport) {
        var remote = this.getRemote(componentName, isClientSideImport);
        return !!remote && remote.__mfeName__ === componentName;
    };
    RemoteService.prototype.getPagesFromTotalItems = function (totalItems) {
        return Math.ceil(parseInt(totalItems) / 10);
    };
    RemoteService.prototype.dynamicImportClientSideMFE = function (__mfeName__) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dynamicImportMFE(__mfeName__, true)];
            });
        });
    };
    RemoteService.prototype.dynamicImportServerSideMFE = function (__mfeName__) {
        return this.dynamicImportMFE(__mfeName__, false);
    };
    /**
     * Recupera la prioriorità del microFE
     * @param __mfeName__ Nome del microFE di cui generare la priorità
     * @param isClientSideImport Flag discriminante per l'import client side
     * @private
     */
    RemoteService.prototype.getMfePriority = function (__mfeName__, isClientSideImport) {
        var _a;
        var priority = 0;
        if (mfe_1.MFE_SETTINGS[__mfeName__]) {
            var settings = mfe_1.MFE_SETTINGS[__mfeName__];
            /*
             * Se il remote è già stato importato allora la sua priorità rispetto ai remotes mai importati senza priorità è più alta,
             * Se il remote ha una priorità avrà sempre priorità superiore ad un widget già importato senza priorità
             */
            priority =
                (this.isAlreadyImported(__mfeName__, isClientSideImport) ||
                    settings.mfePriority !== undefined
                    ? this.MfeAlreadyImportedBasePriority
                    : 0) + ((_a = settings.mfePriority) !== null && _a !== void 0 ? _a : 0);
        }
        return priority;
    };
    RemoteService.prototype.dynamicImportMFE = function (__mfeName__, isClientSideImport) {
        var _this = this;
        if (isClientSideImport === void 0) { isClientSideImport = false; }
        return new Promise(function (resolve, reject) {
            if (_this.isAvailableRemote(__mfeName__)) {
                if (_this.isAlreadyImported(__mfeName__, isClientSideImport)) {
                    helpers_1.ConsoleHelper.info("[RemoteService] dynamicImportMFE with already imported of ", __mfeName__);
                    resolve(_this.getRemote(__mfeName__, isClientSideImport));
                }
                else {
                    helpers_1.ConsoleHelper.info("[RemoteService] dynamicImportMFE with a NEW remote of ", __mfeName__);
                    _this.addInExecQueue({
                        __mfeName__: __mfeName__,
                        isClientSideImport: isClientSideImport,
                        resolve: resolve,
                        reject: reject,
                        priority: _this.getMfePriority(__mfeName__, isClientSideImport),
                    });
                }
            }
            else {
                reject("MFE with name ".concat(__mfeName__, " is not defined in REMOTES_MAP!"));
            }
        });
    };
    RemoteService.prototype.importRemoteBy = function (__mfeName__, attempts) {
        if (attempts === void 0) { attempts = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var remote, remoteJS, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 6]);
                        helpers_1.ConsoleHelper.info("[importRemoteBy] [".concat(__mfeName__, "] Importing "), __mfeName__);
                        return [4 /*yield*/, this.remotesMap[__mfeName__].import()];
                    case 1:
                        remoteJS = _a.sent();
                        helpers_1.ConsoleHelper.info("[importRemoteBy] [".concat(__mfeName__, "] DONE - Importing "), __mfeName__);
                        if (remoteJS) {
                            if (remoteJS.default && "__mfeName__" in remoteJS.default) {
                                if (remoteJS.default.__mfeName__ === __mfeName__) {
                                    remote = remoteJS.default;
                                }
                                else {
                                    throw new Error("[importRemoteBy] [".concat(__mfeName__, "] Error: Mismatch with requested mfeName ").concat(__mfeName__, " and the returned mfeName ").concat(remoteJS.default.__mfeName__, " with RemoteJS ").concat(JSON.stringify(remoteJS.default || {})));
                                }
                            }
                            else {
                                throw new Error("[importRemoteBy] [".concat(__mfeName__, "] Error: exporting RemoteJS default of ").concat(__mfeName__, " is ").concat(JSON.stringify(remoteJS.default || {})));
                            }
                        }
                        else {
                            throw new Error("[importRemoteBy] [".concat(__mfeName__, "] Error: import RemoteJS of ").concat(__mfeName__, " is ").concat(remoteJS));
                        }
                        return [3 /*break*/, 6];
                    case 2:
                        error_1 = _a.sent();
                        if (!(attempts <= this.MAX_ATTEMPTS &&
                            !"".concat(error_1).match(/Container missing/))) return [3 /*break*/, 4];
                        helpers_1.ConsoleHelper.error("[importRemoteBy] [".concat(__mfeName__, "] Error attempts ").concat(attempts), error_1);
                        return [4 /*yield*/, new Promise(function (res) {
                                var waitingTime = helpers_1.EnvironmentHelper.isRunningTest()
                                    ? 100
                                    : 500 * attempts;
                                helpers_1.ConsoleHelper.info("[importRemoteBy] [".concat(__mfeName__, "] Waiting "), waitingTime, "ms");
                                setTimeout(res, waitingTime);
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4: throw error_1;
                    case 5: return [3 /*break*/, 6];
                    case 6:
                        if (!remote) {
                            return [2 /*return*/, this.importRemoteBy(__mfeName__, attempts + 1)];
                        }
                        else {
                            helpers_1.ConsoleHelper.info("[importRemoteBy] SUCCESS - Importing ", __mfeName__);
                            return [2 /*return*/, remote];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteService.prototype.dynamicImportAllMFE = function (mfeNames, isClientSideImport) {
        var _this = this;
        if (mfeNames === void 0) { mfeNames = []; }
        if (isClientSideImport === void 0) { isClientSideImport = false; }
        return Promise.allSettled(mfeNames.map(function (__mfeName__) {
            return _this.dynamicImportMFE(__mfeName__, isClientSideImport);
        }));
    };
    RemoteService.className = "RemoteService";
    return RemoteService;
}(RemotesImporter_service_1.RemotesImporterService));
exports.RemoteService = RemoteService;
